import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { IFloatingFilterParams, TextFilterModel } from 'ag-grid-enterprise';
import './PasteOnlyFloatingFilter.scss';

export default forwardRef((props: IFloatingFilterParams, ref) => {
  const [currentValue, setCurrentValue] = useState<string | undefined>('');
  const inputRef = useRef<HTMLInputElement>(null);

  // expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => {
    return {
      onParentModelChanged(parentModel: TextFilterModel) {
        if (!inputRef.current) return;
        if (!parentModel) {
          inputRef.current.value = '';
          setCurrentValue('');
        } else {
          inputRef.current.value = '';
          setCurrentValue(parentModel.filter ?? '');
        }
      },
    };
  });

  const onInputBoxChanged = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const val = e.clipboardData.getData('text/plain') || '';

    if (val === '') {
      // Remove the filter
      props.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      return;
    }

    setCurrentValue(val);
    props.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged('contains', val);
    });
  };

  const handleClear = () => {
    props.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged(null, null);
    });
    return;
  };

  return (
    <div className="ag-floating-filter-input" role="presentation">
      <div role="presentation" className="ag-labeled ag-label-align-left ag-text-field ag-input-field">
        <div className="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper pasteOnly" role="presentation">
          <input
            ref={inputRef}
            type="text"
            placeholder="Paste Only"
            onPaste={onInputBoxChanged}
            value={currentValue}
            className="ag-input-field-input ag-text-field-input"
            aria-label="Paste Only Filter"
          />
          <span className="clear" onClick={handleClear} />
        </div>
      </div>
    </div>
  );
});
